import React, { createContext, useContext, useState, useEffect } from 'react';

export const CardContext = createContext({
    cardNumber: '',
    tickets: [],
    setCardNumber: () => {},
    setTickets: () => {},
    loading: false,
});

export const CardProvider = ({ children }) => {
    const [cardNumber, setCardNumber] = useState(() => localStorage.getItem('cardNumber') || '');
    const [tickets, setTickets] = useState(() => {
        try {
            const storedTickets = localStorage.getItem('tickets');
            return storedTickets ? JSON.parse(storedTickets) : [];
        } catch (error) {
            console.error('Помилка парсингу tickets з localStorage:', error);
            return [];
        }
    });
    const [loading, setLoading] = useState(false);

    // Синхронізація з localStorage
    useEffect(() => {
        localStorage.setItem('cardNumber', cardNumber);
    }, [cardNumber]);

    useEffect(() => {
        localStorage.setItem('tickets', JSON.stringify(tickets));
    }, [tickets]);

    // Отримання квитків при зміні cardNumber
    useEffect(() => {
        if (cardNumber) {
            setLoading(true);
            const url = `https://epass.easypay.ua/api/customer/${cardNumber}/tickets`;

            fetch(url)
                .then(response => {
                    if (!response.ok) {
                        throw new Error(`HTTP error! Status: ${response.status}`);
                    }
                    return response.json();
                })
                .then(data => {
                    // Якщо API повертає об'єкт з ключем results, використати його, інакше — безпосередньо data
                    const fetchedTickets = data.results || data;
                    if (Array.isArray(fetchedTickets)) {
                        setTickets(fetchedTickets);
                    } else {
                        setTickets([]);
                    }
                })
                .catch(error => {
                    console.error('Помилка отримання тікетів:', error);
                    setTickets([]);
                })
                .finally(() => {
                    setLoading(false);
                });
        }
    }, [cardNumber]);

    return (
        <CardContext.Provider value={{ cardNumber, setCardNumber, tickets, setTickets, loading }}>
            {children}
        </CardContext.Provider>
    );
};

export const useCardContext = () => {
    return useContext(CardContext);
};